import { useState, useEffect } from 'react'
import moment from 'moment'
import * as R from 'ramda'

export default function useQueryFilter(search) {
  const [periodo, setPeriodo] = useState('')
  const [queryFilter, setQueryFilter] = useState({})

  useEffect(() => {
    const params = new URLSearchParams(search)
    const { ...query } = R.fromPairs([...params.entries()])

    if (query.visualizacao === 'hoje') {
      query.dataInicio = moment()
        .second(0)
        .minute(0)
        .hour(0)
        .format('YYYY-MM-DD HH:mm:ss')
      query.dataFim = moment()
        .add(1, 'day')
        .second(0)
        .minute(0)
        .hour(0)
        .format('YYYY-MM-DD HH:mm:ss')
    } else if (query.visualizacao === 'ontem') {
      query.dataInicio = moment()
        .subtract(1, 'day')
        .second(0)
        .minute(0)
        .hour(0)
        .format('YYYY-MM-DD HH:mm:ss')
      query.dataFim = moment()
        .second(0)
        .minute(0)
        .hour(0)
        .format('YYYY-MM-DD HH:mm:ss')
    } else if (query.visualizacao === 'historico') {
      query.dataInicio = moment(query.dataInicio)
        .second(0)
        .minute(0)
        .hour(0)
        .format('YYYY-MM-DD HH:mm:ss')
      query.dataFim = moment(query.dataFim)
        .add(1, 'day')
        .second(0)
        .minute(0)
        .hour(0)
        .format('YYYY-MM-DD HH:mm:ss')
    }

    if (query.visualizacao === 'hoje') {
      setPeriodo('Hoje')
    } else if (query.visualizacao === 'ontem') {
      setPeriodo('Ontem')
    } else if (query.dataInicio && query.dataFim) {
      setPeriodo(
        `${moment(query.dataInicio).format('DD/MM/YYYY')} a ${moment(
          query.dataFim
        )
          .subtract(1, 'day')
          .format('DD/MM/YYYY')}`
      )
    } else {
      setPeriodo('Filtro não selecionado')
    }

    setQueryFilter(query)
  }, [search])

  return [queryFilter, periodo]
}
